export default __webpack_public_path__ + "static/media/ico-selection-ac.0b665ef4.svg";